import moment from 'moment';
import { getToday, formatDate } from '../../shared/services/dateService';

export const getWeekCheckBoxes = (selectedDate, unavailablePeriods) => {
  const weeksInMonth = getWeeksInMonth(selectedDate);

  return weeksInMonth.map((week, index) => {
    const weekStart = moment(week.start);
    const weekEnd = moment(week.end);

    const isPastWeek = weekEnd.isSameOrBefore(getToday());

    const eventInWeek = unavailablePeriods.some(period =>
      isEventInWeek(weekStart, weekEnd, period)
    );
    const isUnavailableWeek = unavailablePeriods.some(item => {
      return !item.eventId && moment(item.start, 'YYYY/MM/DD').isSame(weekStart, 'day');
    });

    const disabled = eventInWeek || isPastWeek;
    const checked = !disabled && !isUnavailableWeek;

    return {
      ...week,
      id: index,
      checked,
      disabled
    };
  });
};

const getWeeksInMonth = selectedDate => {
  const startOfFirstWeek = moment(selectedDate).startOf('month').startOf('week');
  const endOfLastWeek = moment(selectedDate).endOf('month').endOf('week');
  const weeks = [];

  let currentWeekStart = startOfFirstWeek.clone();

  while (currentWeekStart.isBefore(endOfLastWeek)) {
    const currentWeekEnd = currentWeekStart.clone().endOf('week');
    weeks.push({
      start: formatDate(currentWeekStart),
      end: formatDate(currentWeekEnd)
    });
    currentWeekStart.add(1, 'week');
  }

  return weeks;
};

const isEventInWeek = (weekStart, weekEnd, period) => {
  if (!period.eventId) {
    return false;
  }

  const eventStart = moment(period.start).startOf('week');
  const eventEnd = moment(period.end).startOf('week');

  return (
    (eventStart.isSameOrBefore(weekEnd) && eventEnd.isSameOrAfter(weekStart)) ||
    (eventStart.isBefore(weekStart) && eventEnd.isAfter(weekEnd))
  );
};
